import { CHECKOUT_SITE_ADDRESS_ERROR } from '@trashlab/api/src/domains/consumer/utils/checkout-site-address';

const GENERIC_CHECKOUT_PAYMENT_ERROR =
  'Payment failed. Please check your card details and try again.';

export const CHECKOUT_DELIVERY_DATE_PASSED_ERROR =
  'Your selected delivery date has passed. Please return to the date step and select a new delivery date.';

const TECHNICAL_CHECKOUT_ERROR_PATTERN =
  /ECONNREFUSED|prisma|drizzle|Internal server error/i;

export function getCheckoutErrorMessage(error: unknown) {
  const raw = error instanceof Error ? error.message : '';
  const isTechnical =
    !raw || TECHNICAL_CHECKOUT_ERROR_PATTERN.test(raw) || raw.length > 200;

  return isTechnical ? GENERIC_CHECKOUT_PAYMENT_ERROR : raw;
}

export function shouldSuggestDifferentCheckoutPaymentMethod(
  checkoutErrorMessage: string | null,
) {
  return (
    checkoutErrorMessage !== null &&
    checkoutErrorMessage !== CHECKOUT_SITE_ADDRESS_ERROR &&
    checkoutErrorMessage !== CHECKOUT_DELIVERY_DATE_PASSED_ERROR
  );
}
